<template>
	<el-table :data="tableData" border style="width: 100%">
		<el-table-column prop="name" label="参数名" width="180">
		</el-table-column>
		<el-table-column prop="shuoming" label="说明" width="180">
		</el-table-column>
		<el-table-column prop="type" label="类型">
		</el-table-column>
		<el-table-column prop="fanwei" label="取值范围">
		</el-table-column>
		<el-table-column prop="pos" label="参数位置">
		</el-table-column>
		<el-table-column prop="select" label="是否必选">
		</el-table-column>
	</el-table>
</template>

<script>
	export default {
		props: ["tableData"]
	}
</script>

<style scoped="scoped">
	.table-contain {
		margin: 20px 0;
	}
</style>
